export enum SincronizadorEquipamentoHistoricoTipoEnum {
    NuvemLocal = 'local/nuvem',
    ColetorSincronizador = 'coletor/sincronizador',
}
